<template>
  <v-container 
    style="
      padding: 0;
      margin-top: 122px;
    "
    fluid
  >
    <status-bar :showBackButton="true"></status-bar>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card class="mx-5 mb-4">
            <v-card-title>
              <h1 class="display-1">
                Send Bids
              </h1>
            </v-card-title>
            <v-card-text class="px-5 pb-5">
              <p class="mb-3">
                <strong>Suggested order of sending bids:</strong>
              </p>
              <ol class="suggested-order mb-4">
                <li class="mb-2">
                  Send the level pay offer to all of your current existing customers.
                  <ol class="mt-2" type="a">
                    <li class="mb-2">These are your current loyal customers. Establish your monthly paycheck by giving these customers the opportunity to switch.</li>
                    <li>If you have questions about how to enter your customer information, please contact support@certainfee.com.</li>
                  </ol>
                </li>
                <li class="mb-2">
                  Use CertainFee to send bids to potential customers.
                  <ol class="mt-2" type="a">
                    <li class="mb-2">You can add potential customers to your list from your vehicle, your customer's home, or your office.</li>
                    <li class="mb-2">Responses will come directly to you via email and text.</li>
                    <li>For the ones that respond, "Yes," switch their payment option to "recurring" in your accounting system.</li>
                  </ol>
                </li>
                <li class="mb-2">
                  If you cannot upload a CSV file when you set up your CertainFee account, then you will need to add all of your customer information individually or use the sample CSV file to create your list and upload.
                  <p class="mt-2 mb-0">
                    As you are asked for more bids, you will just add them to your member list and message them individually.
                  </p>
                </li>
                <li>
                  Send your subscription bid via all mediums: text, email, mail. The more touches the better. Google Rule of 7.
                  <ol class="mt-2" type="a">
                    <li class="mb-2">You can send your initial email and text message to all of your customers by clicking on the empty box under Customer List and to the left of First Name.</li>
                    <li class="mb-2">Then to the far right of the Customer List header, you will click on the box, Text Selected followed by Email Selected.</li>
                    <li>Responses will arrive to your phone number and email that you listed in the bid to your customers.</li>
                  </ol>
                </li>
              </ol>
              <p class="mb-3">
                To send a bid to a single customer, click the "Send Text" or "Send Email" button in that customer's row to immediately send them a link to the subscription offer.
              </p>
              <p class="mb-3">
                Click "Preview Document" to see the subscription offer that will be sent to each customer. CertainFee built the whole thing for you (you're welcome 😊). If your client is really old-school, you can print it out and mail it. The document is designed to be folded and mailed in
                <a
                  href="#"
                  class="info-link"
                  @click.prevent="envelopeDialog = true"
                >this type of envelope</a>.
                If you
                <a
                  href="#"
                  class="info-link"
                  @click.prevent="foldingDialog = true"
                >fold it correctly</a>,
                with the addresses facing out, you won't need to print an address label. You might even consider including a self-addressed, pre-stamped return envelope.
              </p>

              <v-dialog
                v-model="envelopeDialog"
                max-width="520"
              >
                <v-card>
                  <v-card-title class="headline">
                    Recommended Envelope
                  </v-card-title>
                  <v-card-text>
                    <p class="mb-2">
                      Send printed bids in this envelope:
                    </p>
                    <p class="mb-0 pl-4">
                      Staples Laser Form Double-Window<br />
                      Item ST473949<br />
                      4.1875 in × 9 in (10.6 cm × 22.9 cm)
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      text
                      @click="envelopeDialog = false"
                    >
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog
                v-model="foldingDialog"
                max-width="760"
              >
                <v-card>
                  <v-card-title class="headline">
                    Folding Instructions
                  </v-card-title>
                  <v-card-text>
                    <p class="mb-3">
                      When folded correctly, the recipient and return addresses will show through the windows—no address label is required.
                    </p>
                    <ol class="pl-4 mb-4">
                      <li class="mb-2">Place the envelope face down on a flat surface.</li>
                      <li class="mb-2">Slide the letter—face up—under the envelope flap until the bottom edge rests against the envelope crease.</li>
                      <li class="mb-2">Fold the bottom edge of the letter up to align with the bottom of the envelope, and press firmly to crease.</li>
                      <li class="mb-2">Turn the letter over and fold the top edge down to meet the folded bottom edge.</li>
                      <li>Insert the folded letter into the envelope with both addresses facing outward.</li>
                    </ol>
                    <v-img
                      class="folding-instructions-image"
                      max-width="720"
                      contain
                      src="../assets/folding-instructions.png"
                      alt="Step-by-step diagram showing how to fold a letter for a double-window envelope"
                    ></v-img>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      text
                      @click="foldingDialog = false"
                    >
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <p class="mb-3">
                Inside the bid message, customers are instructed to contact you directly to sign up for the level-pay option. After they agree to the subscription option, simply go into your account/billing software to update their account.
              </p>
              <p>
                If you have any questions, please email support@certainfee.com.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <SlpCustomerList v-if="pdfUrlLoaded" :key="key" />

          <v-card
            v-else
            class="pa-3"
          >
            <v-skeleton-loader
              class="mx-auto"
              width="100%"
              type="article, article, article, article"
            ></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <Footer></Footer>
  </v-container>
</template>

<script>
import StatusBar from '@/components/StatusBar.vue'
import Footer from '@/components/Footer.vue'
import SlpCustomerList from '@/components/SlpCustomerList.vue'

import { DB } from '../firebase/db'
import { Storage } from '../firebase/storage'

import { mapState } from 'vuex'
import _ from "lodash"

import jsPDF from 'jspdf'
import 'jspdf-autotable'

// Customer letters are rendered once and cached in Storage. Bumping this version
// rebuilds those cached PDFs after the letter layout or wording changes.
// Version 1 is any letter generated before the version was recorded.
const LETTER_TEMPLATE_VERSION = 3

export default {
  name: 'SLPAgreement',
  data(){
    return {
      slpData: undefined,
      currentYear: new Date().getFullYear(),
      pageOne: undefined,
      pdf: undefined,
      customerList: undefined,
      dataURI: undefined,
      customerNum: 1,
      updatedCustomerList: [],
      key: 0,
      pdfUrlLoaded: false,
      newSlpAgreements: false,
      envelopeDialog: false,
      foldingDialog: false,
    }
  },
  components: {
    SlpCustomerList,
    StatusBar,
    Footer,
  },
  computed: {
    ...mapState(['user']),
    contractYear() {
      let date = new Date()
      return date.getMonth() === 11 ? date.getFullYear() + 1 : date.getFullYear()
    },
    priorServiceYear() {
      return this.currentYear - 1
    },
    serviceDescriptionText() {
      // The description is captured in a textarea, so its line breaks are
      // collapsed before it is wrapped as a single letter paragraph.
      return _.trim(_.replace((this.slpData && this.slpData.serviceDescription) || '', /\s+/g, ' '))
    },
    billDateOrdinal() {
      let i = this.slpData.billDate % 10
      if (i === 1 && i != 11) {
        return 'st'
      } else if (i === 2 && i != 12) {
        return 'nd'
      } else if (i === 3 && i != 13) {
        return 'rd'
      } else {
        return 'th'
      }
    }
  },
  methods: {
    getSLPData() {
      // Get SLP Data here
      let customerAccountRef = DB.collection("user").doc(this.user.uid)

      customerAccountRef
        .get()
        .then((user) => {
          user = user.data()
          this.slpData = user.slpAgreement
          this.customerList = user.customerList
          this.dataURI = user.afterPictureBase64
          this.slpData.updateSLPDataFlag = user.updateSLPDataFlag || user.letterTemplateVersion !== LETTER_TEMPLATE_VERSION
          this.generatePdfs()
        }).catch((err) => {
          console.log(err)
        })
    },

    firstPaymentDate(deadlineString, billDate) {
      let deadlineArray = _.words(deadlineString)

      let updatedMonth = this.setFirstPaymentMonth(deadlineArray[1])

      let updatedYear = (updatedMonth === 'Jan') ? String(Number(deadlineArray[3]) + 1) : String(Number(deadlineArray[3]))

      let firstPaymentDate = updatedMonth + ' ' + billDate + ', ' + updatedYear

      return firstPaymentDate
    },

    lastPaymentDate(deadlineString, billDate) {
      let deadlineArray = _.words(deadlineString)

      let updatedMonth = deadlineArray[1]

      // let updatedYear = (updatedMonth === 'Dec') ? String(Number(deadlineArray[3])) : String(Number(deadlineArray[3]) + 1)
      let updatedYear = String(Number(deadlineArray[3]) + 1)
      console.log('updatedYear:', updatedYear)

      let lastPaymentDate = updatedMonth + ' ' + billDate + ', ' + updatedYear

      return lastPaymentDate
    },

    setFirstPaymentMonth(month){
      let updatedMonth
      if (month === 'Jan') {
        updatedMonth = 'Feb'
      } else if (month === 'Feb') {
        updatedMonth = 'Mar'
      } else if (month === 'Mar') {
        updatedMonth = 'Apr'
      } else if (month === 'Apr') {
        updatedMonth = 'May'
      } else if (month === 'May') {
        updatedMonth = 'Jun'
      } else if (month === 'Jun') {
        updatedMonth = 'Jul'
      } else if (month === 'Jul') {
        updatedMonth = 'Aug'
      } else if (month === 'Aug') {
        updatedMonth = 'Sep'
      } else if (month === 'Sep') {
        updatedMonth = 'Oct'
      } else if (month === 'Oct') {
        updatedMonth = 'Nov'
      } else if (month === 'Nov') {
        updatedMonth = 'Dec'
      } else if (month === 'Dec') {
        updatedMonth = 'Jan'
      }

      return updatedMonth
    },

    loggedIn() {
      this.$store.dispatch('loggedIn')
    },

    // Wraps a letter paragraph using the font metrics of the document itself, so
    // the text fills the full measure instead of a guessed character count.
    // Takes the baseline of the first line and returns the baseline of the last.
    writeParagraph(pdfDocument, text, baselineY, layout) {
      let lines = pdfDocument.splitTextToSize(text, layout.width)

      _.forEach(lines, (line, index) => {
        pdfDocument.text(layout.x, baselineY + index * layout.lineHeight, line)
      })

      return baselineY + (lines.length - 1) * layout.lineHeight
    },

    generateParagraph(pdfDocument, textArray, shiftY, lineHeight, shiftX) {
      let itr = 1
      let tempString = ''
      let y = 0
      let numCharsPerLine = 80

      let x = shiftX ? shiftX : 20

      for(let i = 0; i < textArray.length; i++) {
        tempString = tempString + textArray[i] + ' '

        if(i === textArray.length - 1 || tempString.length > numCharsPerLine + 6 && textArray[i + 1].length < 6 || tempString.length > numCharsPerLine && textArray[i + 1].length >= 6){
          y = shiftY + itr * lineHeight 
          pdfDocument.text(x, y, tempString)
          tempString = ''
          itr += 1
        }
      }

      return y
    },

    generateParagraphSmallText(pdfDocument, textArray, shiftY, lineHeight, shiftX) {
      let itr = 1
      let tempString = ''
      let y = 0

      let x = shiftX ? shiftX : 20

      for(let i = 0; i < textArray.length; i++) {
        tempString = tempString + textArray[i] + ' '

        if(i === textArray.length - 1 || tempString.length > 106 && textArray[i + 1].length < 8 || tempString.length > 100 && textArray[i + 1].length >= 8){
          tempString = tempString.replace('superScript', this.billDateOrdinal)
          y = shiftY + itr * lineHeight 
          pdfDocument.text(x, y, tempString)
          tempString = ''
          itr += 1
        }
      }

      return y
    },

    generateTitleText(pdfDocument, textArray, shiftY, lineHeight, shiftX) {
      let itr = 1
      let tempString = ''
      let y = 0

      let x = shiftX ? shiftX : 20

      for(let i = 0; i < textArray.length; i++) {
        tempString = tempString + textArray[i] + ' '

        if(i === textArray.length - 1 || tempString.length > 41 && textArray[i + 1].length < 4 || tempString.length > 37 && textArray[i + 1].length >= 4){
          y = shiftY + itr * lineHeight 
          pdfDocument.text(x, y, tempString)
          tempString = ''
          itr += 1
        }
      }

      return y
    },

    processPhone(phone){
      return '+1 (' + phone.substring(0, 3) + ') ' + phone.substring(3, 6) + '-' + phone.substring(6, 10)
    },

    updateSLPDataFlag(){
      let tenantAccount = DB.collection("user").doc(this.user.uid)
      tenantAccount
        .update({
          updateSLPDataFlag: false,
          letterTemplateVersion: LETTER_TEMPLATE_VERSION,
        })
        .then(() => {
          console.log('updateSLPDataFlag is called')
        })
        .catch((err) => {
          console.error('Error setting Document: ', err)
        })
    },
    
    async generatePdfs() {
      let shiftY = 40

      let pdfPromise = new Promise((resolve, reject) => {
        _.forEach(this.customerList, (customer) => {
          if (_.has(customer, 'pdfUrl') && !this.slpData.updateSLPDataFlag) {
    
          this.updatedCustomerList.push(customer)
          if (this.customerNum === this.customerList.length && this.newSlpAgreements) {
    
            let customerAccountRef = DB.collection("user").doc(this.user.uid)
            customerAccountRef
              .set({
                customerList: this.updatedCustomerList
              }, { merge: true })
              .then(() => {
                this.key += 1
                resolve(this.updatedCustomerList)
              })
              .catch((err) => {
                reject(err)
              })
          } else if (this.customerNum === this.customerList.length && !this.newSlpAgreements) {
            this.pdfUrlLoaded = true
            resolve(this.updatedCustomerList)
          } else {
            this.customerNum += 1
            return
          }
        } else {
            // console.log('this.slpData.updateSLPDataFlag: ',this.slpData.updateSLPDataFlag)
            this.newSlpAgreements = true
            const undiscountedMonthly = (customer.regularPrice * customer.numberOfServices / 12).toFixed(2)
            let offerText = this.slpData.companyName + ' is offering a level-pay option for ' + this.slpData.serviceName + '.'
            let descriptionText = this.serviceDescriptionText
            let ratesText = 'Your current rate is $' + Number(customer.regularPrice).toFixed(2) + ' per service. The level-pay option is 12 monthly payments of $' + undiscountedMonthly + '. Accept by ' + customer.deadline + ' for a ' + customer.percentDiscount + '% discount and pay $' + (customer.levelPayMonthlyCost != null ? Number(customer.levelPayMonthlyCost).toFixed(2) : '') + ' per month.'
            let termsText = 'Terms: This offer is based on ' + customer.numberOfServices + ' services per year. Pay by debit or credit card and update your payment information when necessary. Cancel at any time; cancellation ends the discount. Payment is collected on the ' + this.slpData.billDate + this.billDateOrdinal + ' day of each month, beginning next month.'

            // Letter 
            // width: 215.9mm
            // height: 279.4mm

            // dataURIWidth = 26.5mm
            // Horizontal Margin: 20mm

            let dataURIWidth = 26.5
            // let dataURIHeight = 26.5
            let letterWidth = 215.9
            let letterHorizontalMargin = 24.3
            // let letterHeight = 279.4

            let doc = new jsPDF({
              orientation: 'p',
              unit: 'mm',
              format: 'letter',
              putOnlyUsedFonts:false,
              floatPrecision: 16
            })

            doc.setFont("helvetica")
            doc.setFontSize(21)

            doc.addImage(this.dataURI, letterWidth - dataURIWidth - letterHorizontalMargin, 15)

            doc.setFontSize(12)

            doc.text(letterHorizontalMargin, 25, this.slpData.companyName)
            doc.text(letterHorizontalMargin, 30, this.slpData.address.street)
            doc.text(letterHorizontalMargin, 35, this.slpData.address.city + ', ' + this.slpData.address.state + ' ' + this.slpData.address.zip)

            doc.text(letterHorizontalMargin, shiftY + 20, customer.firstName + ' ' + customer.lastName)
            doc.text(letterHorizontalMargin, shiftY + 25, customer.address)
            doc.text(letterHorizontalMargin, shiftY + 30, customer.city + ', ' + customer.state + ' ' + customer.zip)
            doc.text(letterHorizontalMargin, shiftY + 57, 'Dear ' + customer.firstName + ':')

            // The body has to carry the service description and still leave room
            // for the rate table on page one, so it is set a little tighter than
            // the letterhead above it.
            let bodyLayout = {
              x: letterHorizontalMargin,
              width: letterWidth - letterHorizontalMargin * 2,
              lineHeight: 4.6,
            }
            let paragraphGap = bodyLayout.lineHeight + 2.5

            doc.setFontSize(11)

            let bodyY = this.writeParagraph(doc, offerText, shiftY + 61, bodyLayout)

            if (descriptionText) {
              bodyY = this.writeParagraph(doc, descriptionText, bodyY + paragraphGap, bodyLayout)
            }

            bodyY = this.writeParagraph(doc, ratesText, bodyY + paragraphGap, bodyLayout)
            bodyY = bodyY + paragraphGap

            doc.text(letterHorizontalMargin, bodyY, 'Contact ' + this.slpData.companyName + ' to sign up!')
            doc.text(letterHorizontalMargin, bodyY + 5, this.processPhone(this.slpData.businessPhone))
            doc.text(letterHorizontalMargin, bodyY + 10, this.slpData.businessEmail)
            bodyY = bodyY + 10

            let y3 = this.writeParagraph(doc, termsText, bodyY + paragraphGap, bodyLayout)

            // AutoTable Docs
            // https://github.com/simonbengtsson/jsPDF-AutoTable
            doc.autoTable({
              valign: 'center',
              body: [
                [
                  'Standard Billing',
                  'The amount varies based on services completed.\nPayment is due upon receipt.',
                  '$' + customer.regularPrice + ' per service'
                ],

                [{
                  content: 'ºMonthly Payment',
                  colSpan: 1
                  },
                  {
                  content: 'Same payment amount due on the ' + this.slpData.billDate + this.billDateOrdinal + ' of each month. First payment is due ' + this.firstPaymentDate(customer.deadline, this.slpData.billDate) + '. Last payment is due ' + this.lastPaymentDate(customer.deadline, this.slpData.billDate) + '.',
                  colSpan: 1,
                  styles: { halign: 'center' },
                  },
                  {
                  content: '$' + (Math.round(customer.regularPrice * customer.numberOfServices / 12).toFixed(2)) + ' per month \n\nReturn by ' + customer.deadline + ' for the ' + customer.percentDiscount + '% discount and pay:\n$'+ customer.levelPayMonthlyCost + ' per month!',
                  colSpan: 1
                  }
                ],

                [{
                  content: 'ºThe monthly payment is calculated using ' + customer.numberOfServices + ' services per year at the standard rate for ' + this.slpData.serviceName + '.',
                  colSpan: 3,
                  styles: { halign: 'center' },
                }],

                [{
                  content: 'If you have questions about this bid, please contact us at '+ this.processPhone(this.slpData.businessPhone)+' or '+this.slpData.businessEmail+'.',
                  colSpan: 3,
                  styles: { halign: 'center' },
                }]
              ],
              startY: y3 + 8,
              // tableWidth: 100,
              margin: {
                left: letterHorizontalMargin,
                right: letterHorizontalMargin,
              }
            })

            doc.addPage()

            doc.setFontSize(18)
            let paraFour = _.split(this.slpData.companyName + ' | 12 Month Level-Pay Agreement', ' ')

            doc.addImage(this.dataURI, 20, 15)

            this.generateTitleText(doc, paraFour, 15, 10, 55) + 14
            let verticalSpace = 49

            doc.setFontSize(14)
            doc.text(20, verticalSpace + 3,  'Customer Name: ' + customer.firstName + ' ' + customer.lastName)
            doc.setFontSize(11)

            verticalSpace = verticalSpace + 10
            
            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 20, verticalSpace - 1)

            let paraFive = _.split('Yes! I would like to be on the ' + this.slpData.serviceName + ' Monthly Payment Option, with 12 equal monthly payments of $' + customer.levelPayMonthlyCost+ ' for the next 12 months beginning date of signing specified below.', ' ')
            verticalSpace = this.generateParagraph(doc, paraFive, verticalSpace - 4, 7, 30) + 5

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 30, verticalSpace - 1)

            // here
            doc.text(40, verticalSpace + 4, 'I authorize ' + this.slpData.companyName + ' to automatically charge my credit card ')
            doc.text(40, verticalSpace + 8, 'on the ' + this.slpData.billDate + this.billDateOrdinal + ' of each month.*')
            verticalSpace = verticalSpace + 12
            
            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 30, verticalSpace - 1)

            doc.text(40, verticalSpace + 4, 'I will send a check. Please send my invoice via:')
            verticalSpace = verticalSpace + 7

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 40, verticalSpace - 1)

            doc.text(50, verticalSpace + 4, 'mail: _______________________________')
            verticalSpace = verticalSpace + 7

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 40, verticalSpace - 1)

            doc.text(50, verticalSpace + 4, 'email: _______________________________')
            verticalSpace = verticalSpace + 7

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 20, verticalSpace - 1)

            doc.text(30, verticalSpace + 4, 'I prefer the standard billing option for ' + this.contractYear + '.')
            verticalSpace = verticalSpace + 7

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 30, verticalSpace - 1)

            // here
            doc.text(40, verticalSpace + 4, 'I authorize ' + this.slpData.companyName + ' to automatically charge my credit card ')
            doc.text(40, verticalSpace + 8, 'on the ' + this.slpData.billDate + this.billDateOrdinal + ' of each month.*')
            verticalSpace = verticalSpace + 12

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 30, verticalSpace - 1)

            doc.text(40, verticalSpace + 4, 'I will send a check. Please send my invoice via:')
            verticalSpace = verticalSpace + 7

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 40, verticalSpace - 1)

            doc.text(50, verticalSpace + 4, 'mail: _______________________________')
            verticalSpace = verticalSpace + 7

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 40, verticalSpace - 1)

            doc.text(50, verticalSpace + 4, 'email: _______________________________')
            verticalSpace = verticalSpace + 7

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 20, verticalSpace - 1)

            doc.text(30, verticalSpace + 4, 'No, I have decided not to contract with ' + this.slpData.companyName + '.')

            verticalSpace = verticalSpace + 20

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 93, verticalSpace - 5)

            doc.text(20, verticalSpace, '*Credit Card Billing Information (optional)')

            doc.text(100, verticalSpace, 'Please continue to use the same card info currently on file.')

            verticalSpace = verticalSpace + 7

            doc.text(20, verticalSpace, 'Name on Card:___________________________')
            
            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 114, verticalSpace - 5)
            doc.text(121, verticalSpace, 'Visa')

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 132, verticalSpace - 5)
            doc.text(139, verticalSpace, 'MasterCard')

            doc.addImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAANElEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5Ec1jGoYMA0kJ2+SM9AgAgAUXHvBY5BD6QAAAABJRU5ErkJggg==', 161, verticalSpace - 5)
            doc.text(168, verticalSpace, 'Discover')

            verticalSpace = verticalSpace + 7

            doc.text(20, verticalSpace, 'Billing Address:___________________________ City:______________ ZIP:___________')

            verticalSpace = verticalSpace + 7

            doc.text(20, verticalSpace, 'Card Number:___________________________ Expiration:____ / ____ CVV:_______')

            doc.setFontSize(10)

            let finePrint = _.split('ºThis agreement must be returned with payment for the month in which it is received to qualify for the discounted monthly rate. If the agreement is received after ' + customer.deadline + ', the monthly payment will be $' + (Math.round(customer.regularPrice * customer.numberOfServices / 12).toFixed(2)) + '. Monthly installments must be received by the '+this.slpData.billDate+'superScript of each month. Late payments may result in a return to standard billing at the full rate. If the customer terminates this agreement, the discount ends and year-to-date charges will be recalculated at the standard rate. Any difference between accrued charges and monthly installments must be paid within 30 days. If the difference is owed to the customer, '+this.slpData.companyName+' will issue a refund.', ' ')

            verticalSpace = verticalSpace + 12

            verticalSpace = this.generateParagraphSmallText(doc, finePrint, verticalSpace, 5) + 12

            doc.setFontSize(12)

            doc.text(20, verticalSpace, 'Signature:__________________________________________ Date:_______________')

            let pdf = doc.output('blob')

            let uniqueString = _.toString(_.random(0, 9)) + _.toString(_.random(0, 9)) + _.toString(_.random(0, 9)) + _.toString(_.random(0, 9)) + _.toString(_.random(0, 9)) + _.toString(_.random(0, 9)) + _.toString(_.random(0, 9)) + _.toString(_.random(0, 9)) + _.toString(_.random(0, 9)) + _.toString(_.random(0, 9))

            let storageRef = Storage.ref(this.user.uid+'/customerPDFs/'+uniqueString+'.pdf')

            storageRef.put(pdf, { contentType: 'application/pdf'})
              .then(() => {
                storageRef.getDownloadURL()
                  .then((downloadURL) => {
                    customer.pdfUrl = downloadURL

                    this.updatedCustomerList.push(customer)
                    if (this.customerNum === this.customerList.length) {              

                      let customerAccountRef = DB.collection("user").doc(this.user.uid)
                      customerAccountRef
                        .set({
                          customerList: this.updatedCustomerList
                        }, { merge: true })
                        .then(() => {
                          this.key += 1
                          this.pdfUrlLoaded = true
                          resolve(this.updatedCustomerList)
                        })
                        .catch((err) => {
                          console.error('Error setting Document: ', err)
                        })
                    }
                    this.customerNum += 1
                  })
              })
          }
        })
      })
      await pdfPromise
      this.updateSLPDataFlag()
      this.slpData.updateSLPDataFlag = false
      this.pdfUrlLoaded = true
    }
  },
  mounted() {
    this.getSLPData()
  }
}
</script>

<style scoped>
.suggested-order,
.suggested-order ol {
  padding-left: 24px;
}

.suggested-order {
  list-style-type: decimal;
}

.suggested-order ol {
  list-style-type: lower-alpha;
}

.info-link {
  color: #1976d2;
  text-decoration: underline;
  white-space: nowrap;
}

.folding-instructions-image {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
}
</style>